import { __assign } from "tslib";
import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
export var RoundTable = function (genericRoundTableProps) {
    var EditorOrViewerRoundTable = useContext(ComponentContext).RoundTable;
    return React.createElement(EditorOrViewerRoundTable, __assign({}, genericRoundTableProps));
};
//# sourceMappingURL=round-table.js.map